<template>
  <div class="box3">
    <pageTitle title="AI运维&nbsp;&nbsp;解锁云智能时代薪赛道" />
    <img class="video" @click="viewVideo" src="../../../assets/coursePage/linux/box3/video.png"/>
    <div class="bottom">
       <img src="../../../assets/coursePage/linux/box3/img01.png"/>
       <img src="../../../assets/coursePage/linux/box3/img02.png"/>
       <img src="../../../assets/coursePage/linux/box3/img03.png"/>
    </div>
     <CourseVideo :src="videoSrc" :flag="videoFlag" @close="close" specialStyle="2" autoplay="true"></CourseVideo>
  </div>
</template>

<script>
import CourseVideo from "../common/courseVideo.vue";
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
    CourseVideo
  },
  data() {
    return {
      videoSrc: '',
      videoFlag: false,
    };
  },
  computed: {
   
  },
  methods:{
    close() {
     
        this.videoSrc = ''
        this.videoFlag = false
    },
    viewVideo(){
      this.videoSrc = 'https://file.boxuegu.com/bxgyingxiao/ywxkjs.mp4'
        this.videoFlag = true
    },
  }
};
</script>

<style lang="less" scoped>
.box3 {
  background: url("../../../assets/coursePage/linux/box3/bg.png") no-repeat;
  background-size: 100% 100%;
  padding: 60px 0 40px;
  .video{
    padding: 48px 30px 40px;
    width: 100%;
    box-sizing: border-box;
  }
  .bottom{
    display: flex;
    overflow-x: auto;
    width: 100%;
    img{
      width: 374px;
      margin: 0 0 40px 30px;
    }
    img:last-child{margin-right: 30px;}
  }
}
</style>
